import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { SITE_LIST,PREFILLED_GATE_DATA,SAVE_RENEWAL_REQUEST,PREFILLED_REQUEST,REQUEST_LIST,REQUEST_DETAILS,FILTERS,PREVIOUS_REQUESTS,BASE_PRICES,UPDATE_CLIENT_STATUS,CLIENT_STATUS_OPTIONS} from "./type";

export const getSiteList = (queryObj = null, page = 1,is_pagination_required=true,pageSize=15) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?contract_status=${encodeURIComponent(queryObj.contract_status)}`
    + `&contract_type=${encodeURIComponent(queryObj.contract_type)}`
    + `&site_name=${encodeURIComponent(queryObj.site_name)}`
    + `&site_number=${encodeURIComponent(queryObj.site_number)}`
    + `&project_id=${encodeURIComponent(queryObj.project_id)}`
    + `&live_date=${encodeURIComponent(queryObj.live_date)}`
    + `&expiry_date=${encodeURIComponent(queryObj.expiry_date)}`
    + `&bucket=${encodeURIComponent(queryObj.bucket)}`
    + `&renewal_status=${encodeURIComponent(queryObj.renewal_status)}`
    + `&city_id=${encodeURIComponent(queryObj.city_id)}`
    + `&page=${encodeURIComponent(page)}`
    + `&is_pagination_required=${encodeURIComponent(is_pagination_required)}`
    + `&pageSize=${encodeURIComponent(pageSize)}`;

    if (queryObj.live_from_date !== undefined) {
        filterQuery += `&live_from_date=${encodeURIComponent(queryObj.live_from_date)}`;
    }
    if (queryObj.live_to_date !== undefined) {
        filterQuery += `&live_to_date=${encodeURIComponent(queryObj.live_to_date)}`;
    }
    if (queryObj.expiry_from_date !== undefined) {
        filterQuery += `&expiry_from_date=${encodeURIComponent(queryObj.expiry_from_date)}`;
    }
    if (queryObj.expiry_to_date !== undefined) {
        filterQuery += `&expiry_to_date=${encodeURIComponent(queryObj.expiry_to_date)}`;
    }
  }
  try {
    dispatch({
      type: SITE_LIST,
      payload: {},
    });
    let apiUrl=(filterQuery!="")?
                `${Config.contractRenewal.getSiteList}${filterQuery}`:
                `${Config.contractRenewal.getSiteList}?page=${page}&is_pagination_required=${is_pagination_required}&pageSize=${pageSize}`;

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );
    console.log("ACTION",apiUrl);
    if (res) {
      const { data } = res;
      dispatch({
        type: SITE_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch(err) {
    dispatch({
      type: SITE_LIST,
      payload: {},
    });
  }
};

export const getRequestList = (queryObj = null, page = 1,is_pagination_required=true,pageSize=15) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    console.log(queryObj)
    filterQuery = `?contract_status=${encodeURIComponent(queryObj.contract_status)}`
    + `&contract_type=${encodeURIComponent(queryObj.contract_type)}`
    + `&site_name=${encodeURIComponent(queryObj.site_name)}`
    + `&site_number=${encodeURIComponent(queryObj.site_number)}`
    + `&project_id=${encodeURIComponent(queryObj.project_id)}`
    + `&live_date=${encodeURIComponent(queryObj.live_date)}`
    + `&expiry_date=${encodeURIComponent(queryObj.expiry_date)}`
    + `&bucket=${encodeURIComponent(queryObj.bucket)}`
    + `&renewal_status=${encodeURIComponent(queryObj.renewal_status)}`
    + `&city_id=${encodeURIComponent(queryObj.city_id)}`
    + `&page=${encodeURIComponent(page)}`
    + `&is_pagination_required=${encodeURIComponent(is_pagination_required)}`
    + `&pageSize=${encodeURIComponent(pageSize)}`;;

    if (queryObj.live_from_date !== undefined) {
      filterQuery += `&live_from_date=${encodeURIComponent(queryObj.live_from_date)}`;
    }
    if (queryObj.live_to_date !== undefined) {
        filterQuery += `&live_to_date=${encodeURIComponent(queryObj.live_to_date)}`;
    }
    if (queryObj.expiry_from_date !== undefined) {
        filterQuery += `&expiry_from_date=${encodeURIComponent(queryObj.expiry_from_date)}`;
    }
    if (queryObj.expiry_to_date !== undefined) {
        filterQuery += `&expiry_to_date=${encodeURIComponent(queryObj.expiry_to_date)}`;
    }
  }

  try {
    dispatch({
      type: REQUEST_LIST,
      payload: {},
    });
    let apiUrl=(filterQuery!="")?`${Config.contractRenewal.getRequestList}${filterQuery}`:`${Config.contractRenewal.getRequestList}?page=${page}&is_pagination_required=${is_pagination_required}&pageSize=${pageSize}`;

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: REQUEST_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch(err) {
    dispatch({
      type: REQUEST_LIST,
      payload: {},
    });
  }
};


export const getPrefilledGateData = (site_id) => async (dispatch) => {

    try {
      dispatch({
        type: PREFILLED_GATE_DATA,
        payload: {},
      });
      let apiUrl=`${Config.contractRenewal.getPrefilledGateData}`;
      const res = await callWebService(
        callTypes.get,
        "",
        `${apiUrl}?site_id=${site_id}`
      );
      if (res) {
        const { data } = res;
        dispatch({
          type: PREFILLED_GATE_DATA,
          payload: data.response.data,
        });
        return true;
      }
    }
    catch(err) {
      dispatch({
        type: PREFILLED_GATE_DATA,
        payload: {},
      });
    }
  };
  
export const saveRenewalRequest = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            Config.contractRenewal.saveRenewalRequest
        );
        if (res) {
            const { data } = res;
            dispatch({ type: SAVE_RENEWAL_REQUEST, payload: data.response.data });
            return data;
        }
    }catch(err) {
        dispatch({
          type: SAVE_RENEWAL_REQUEST,
          payload: {},
        });
    }
};
export const updateRequestStatus = (request_id) => async (dispatch) => {
  try {
      const res = await callWebService(
          callTypes.patch,
          request_id,
          Config.contractRenewal.updateRequestStatus
      );
      if (res) {
          const { data } = res;
          dispatch({ type: SAVE_RENEWAL_REQUEST, payload: data.response.data });
          return data.status;
      }
  }catch(err) {
      dispatch({
        type: SAVE_RENEWAL_REQUEST,
        payload: {},
      });
  }
};
export const getPrefilledRequestData = (site_id) => async (dispatch) => {
  try {
      dispatch({
      type: PREFILLED_REQUEST,
      payload: {},
      });
      let apiUrl=`${Config.contractRenewal.getPrefilledRequest}`;
      const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}?site_id=${site_id}`
      );
      if (res) {
      const { data } = res;
      dispatch({
          type: PREFILLED_REQUEST,
          payload: data.response.data,
      });
      return true;
      }
  }
  catch(err) {
      dispatch({
      type: PREFILLED_REQUEST,
      payload: {},
      });
  }
}
export const getRenewalRequestDetails = (request_id,site_id=null,showLogs=false) => async (dispatch) => {

  try {
      dispatch({
      type: REQUEST_DETAILS,
      payload: {},
      });
      let apiUrl=`${Config.contractRenewal.getRequestDetails}`;
      const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}?request_id=${request_id}&site_id=${site_id}&show_logs=${showLogs}`
      );
      if (res) {
      const { data } = res;
      dispatch({
          type: REQUEST_DETAILS,
          payload: data.response.data,
      });
      return true;
      }
  }
  catch(err) {
      dispatch({
      type: REQUEST_DETAILS,
      payload: {},
      });
  }
};

export const getFilters = () => async (dispatch) => {
  try {
      dispatch({
      type: FILTERS,
      payload: {},
      });
      let apiUrl=`${Config.contractRenewal.getFilters}`;
      const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
      );
      if (res) {
      const { data } = res;
      dispatch({
          type: FILTERS,
          payload: data.response.data,
      });
      return true;
      }
  }
  catch(err) {
      dispatch({
      type: FILTERS,
      payload: {},
      });
  }
};

export const getPreviousRequestsList = (site_id) => async (dispatch) => {
  try {
      dispatch({
      type: PREVIOUS_REQUESTS,
      payload: {},
      });
      let apiUrl=`${Config.contractRenewal.getPreviousRequests}`;
      const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}?site_id=${site_id}`
      );
      if (res) {
      const { data } = res;
      dispatch({
          type: PREVIOUS_REQUESTS,
          payload: data.response.data,
      });
      return true;
      }
  }
  catch(err) {
      dispatch({
      type: PREVIOUS_REQUESTS,
      payload: {},
      });
  }
}


export const getGateBasePrices = (gate_setup_id,contract_type_id,amc_type,payment_term_id) => async (dispatch) => {
  try {
      dispatch({
        type: BASE_PRICES,
        payload: {},
      });
      let apiUrl=`${Config.contractRenewal.getGateBasePrices}`;
      const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}?gate_setup_id=${gate_setup_id}&contract_type_id=${contract_type_id}&amc_type=${amc_type}&payment_term_id=${payment_term_id}`
      );
      if (res) {
      const { data } = res;
      dispatch({
          type: BASE_PRICES,
          payload: data.response.data,
      });
      return data.response.data;
      }
  }
  catch(err) {
      dispatch({
      type: BASE_PRICES,
      payload: {},
      });
  }
}

export const updateClientRenewalStatus = (data) => async (dispatch) => {
  try {
      dispatch({
      type: UPDATE_CLIENT_STATUS,
      payload: {},
      });
      let apiUrl=`${Config.contractRenewal.updateClientStatus}`;
      const res = await callWebService(
      callTypes.post,
      data,
      `${apiUrl}`
      );
      if (res) {
      const { data } = res;
      dispatch({
          type: UPDATE_CLIENT_STATUS,
          payload: data.response.data,
      });
      return data.response.data;
      }
  }
  catch(err) {
      dispatch({
      type: UPDATE_CLIENT_STATUS,
      payload: {},
      });
  }
}

export const getClientStatusOptions = () => async (dispatch) => {
  try {
      dispatch({
      type: CLIENT_STATUS_OPTIONS,
      payload: {},
      });
      let apiUrl=`${Config.contractRenewal.getClientRemarks}`;
      const res = await callWebService(
      callTypes.get,
      '',
      `${apiUrl}`
      );
      if (res) {
      const { data } = res;
      dispatch({
          type: CLIENT_STATUS_OPTIONS,
          payload: data.response.data,
      });
      return data.response.data;
      }
  }
  catch(err) {
      dispatch({
      type: CLIENT_STATUS_OPTIONS,
      payload: {},
      });
  }
}